import ImportedConfig from "../../public/config.json"

type Config = typeof ImportedConfig.default

export let config: Config

export const loadConfig = async () => {
  const res = await fetch("/config.json")
  if (!res.ok) throw new Error("Failed to load config")

  const host = window.location.host
  const json = Object.freeze(await res.json()) as Record<string, Config>

  config = {
    ...json.default,
    ...json[host],
  }
}
